import { render, staticRenderFns } from "./Chart_Gift.vue?vue&type=template&id=16dc7159&scoped=true"
import script from "./Chart_Gift.vue?vue&type=script&lang=js"
export * from "./Chart_Gift.vue?vue&type=script&lang=js"
import style0 from "./Chart_Gift.vue?vue&type=style&index=0&id=16dc7159&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dc7159",
  null
  
)

export default component.exports